export default "__VITE_ASSET__BF2qr8qz__"